import React from 'react';
import Icon from '../../../components/AppIcon';

const FeatureHighlight = () => {
  const features = [
    {
      icon: 'Zap',
      title: 'Instant Onboarding',
      description: 'Get started in minutes with our guided setup'
    },
    {
      icon: 'Target',
      title: 'Gamified Progress',
      description: 'Track your journey with XP and achievements'
    },
    {
      icon: 'Bot',
      title: 'AI Assistant',
      description: '24/7 support from your personal Bee guide'
    }
  ];

  return (
    <div className="hidden lg:flex flex-col justify-center px-12 py-16 bg-secondary/20 backdrop-blur-sm">
      <div className="max-w-md">
        <h2 className="text-4xl font-bold text-foreground mb-4">
          Transform Your Onboarding Experience
        </h2>
        <p className="text-muted-foreground text-lg mb-12">
          Join thousands of companies reducing onboarding time by 70% with Bee Wise
        </p>

        <div className="space-y-8">
          {features?.map((feature, index) => (
            <div key={index} className="flex items-start gap-4">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center shrink-0">
                <Icon name={feature?.icon} size={24} color="var(--color-primary)" strokeWidth={2} />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-foreground mb-1">
                  {feature?.title}
                </h3>
                <p className="text-muted-foreground">
                  {feature?.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 p-6 bg-card/50 rounded-lg border border-border">
          <div className="flex items-center gap-3 mb-3">
            <Icon name="TrendingUp" size={20} color="var(--color-success)" />
            <span className="text-sm font-semibold text-success">3x Faster Productivity</span>
          </div>
          <p className="text-sm text-muted-foreground">
            New hires reach full productivity 3 times faster with our structured approach
          </p>
        </div>
      </div>
    </div>
  );
};

export default FeatureHighlight;